import { LayoutGrid, List } from "lucide-react";

/**
 * ViewToggle — grid/list view mode pill toggle.
 *
 * Props:
 *   value    — "grid" | "list"
 *   onChange — fn(newMode: "grid" | "list")
 */
const ViewToggle = ({ value, onChange }) => (
  <div className="flex items-center gap-1 p-1 rounded-lg bg-fill-gray-100 dark:bg-fill-dialog-border">
    <button
      type="button"
      onClick={() => onChange("grid")}
      title="Grid view"
      aria-label="Grid view"
      aria-pressed={value === "grid"}
      className={`p-1.5 rounded-md transition-colors ${
        value === "grid"
          ? "bg-fill-white dark:bg-fill-dialog-surface text-ink-primary shadow-sm"
          : "text-ink-gray-400 hover:text-ink-gray-700 dark:hover:text-ink-gray-300"
      }`}
    >
      <LayoutGrid className="w-3.5 h-3.5" />
    </button>
    <button
      type="button"
      onClick={() => onChange("list")}
      title="List view"
      aria-label="List view"
      aria-pressed={value === "list"}
      className={`p-1.5 rounded-md transition-colors ${
        value === "list"
          ? "bg-fill-white dark:bg-fill-dialog-surface text-ink-primary shadow-sm"
          : "text-ink-gray-400 hover:text-ink-gray-700 dark:hover:text-ink-gray-300"
      }`}
    >
      <List className="w-3.5 h-3.5" />
    </button>
  </div>
);

export default ViewToggle;
